import React, { useEffect, useState } from "react";
import { Button, Card, Space, Typography, message } from "antd";
import { useNavigate } from "react-router-dom";
import {
    getReturnHistory,
    getReturns,
    getTransactionSchedules,
} from "../api/transactionScheduleApi";
import ROUTE_PATHS from "../routes/routePaths";
import TransactionScheduleDashboard from "../components/transactionSchedule/TransactionScheduleDashboard";

const { Title, Text } = Typography;

function TransactionScheduleDashboardPage() {
    const navigate = useNavigate();
    const [transactions, setTransactions] = useState([]);
    const [returns, setReturns] = useState([]);
    const [returnHistory, setReturnHistory] = useState([]);

    const loadAll = async () => {
        try {
            const [tx, rt, hist] = await Promise.all([
                getTransactionSchedules(),
                getReturns(),
                getReturnHistory(),
            ]);

            setTransactions((tx || []).map((item) => ({ ...item, key: item.id })));
            setReturns((rt || []).map((item) => ({ ...item, key: item.statementId })));
            setReturnHistory(hist || []);
        } catch (error) {
            message.error(error.message || "Хяналтын самбарын мэдээлэл ачаалж чадсангүй");
        }
    };

    useEffect(() => {
        loadAll();
    }, []);

    return (
        <div className="space-y-4">
            <Card bordered={false} className="shadow-sm rounded-2xl">
                <Space direction="vertical" size={4}>
                    <Title level={2} style={{ margin: 0 }}>
                        Гүйлгээний хуваарийн хяналтын самбар
                    </Title>
                    <Text type="secondary">
                        Ерөнхий төлөв, анхаарал шаардлагатай хүсэлтүүд болон хурдан шилжилтүүд
                    </Text>
                    <Space wrap>
                        <Button type="primary" onClick={() => navigate(ROUTE_PATHS.TRANSACTION_SCHEDULE)}>
                            Ажлын дэлгэц рүү орох
                        </Button>
                        <Button onClick={() => navigate(`${ROUTE_PATHS.TRANSACTION_SCHEDULE}?tab=returns`)}>
                            Буцаалтын хэсэг рүү орох
                        </Button>
                    </Space>
                </Space>
            </Card>

            <TransactionScheduleDashboard
                transactions={transactions}
                returns={returns}
                returnHistory={returnHistory}
                onGoSchedules={() => navigate(ROUTE_PATHS.TRANSACTION_SCHEDULE)}
                onQuickFilter={(mode) => {
                    const search = new URLSearchParams();

                    if (mode === "EMPTY") {
                        search.set("status", "EMPTY");
                    }

                    if (mode === "WAITING") {
                        search.set("queue", "waiting");
                    }

                    if (mode === "RETURNS") {
                        search.set("tab", "returns");
                    }

                    navigate(`${ROUTE_PATHS.TRANSACTION_SCHEDULE}?${search.toString()}`);
                }}
                onOpenRecord={(record) => {
                    navigate(`${ROUTE_PATHS.TRANSACTION_SCHEDULE}?openId=${record.id}`);
                }}
            />
        </div>
    );
}

export default TransactionScheduleDashboardPage;